import { useTranslation } from 'next-i18next';
import Head from 'next/head';

import { useTrackVisitorEvents } from '@catawiki/runtime-toolkit';

import type { LayoutAssets } from '@/shared/helpers/api/assets';
import { useLocale } from '@/shared/hooks/useLocale';

import { SellerRegister } from './features/SellerRegister/SellerRegister';

export interface RegisterPageProps {
  assetsData?: LayoutAssets;
  isUserLoggedIn: boolean;
  APP_IMGPROXY_HOST: string;
  pageType?: string;
}

export const RegisterPage = ({
  isUserLoggedIn,
  APP_IMGPROXY_HOST,
}: RegisterPageProps) => {
  const { t } = useTranslation();

  const { internalLocale } = useLocale();

  useTrackVisitorEvents(internalLocale);

  return (
    <>
      <Head>
        <title>{t('sell_special_objects')} - Catawiki</title>
      </Head>

      <SellerRegister
        isUserLoggedIn={isUserLoggedIn}
        APP_IMGPROXY_HOST={APP_IMGPROXY_HOST}
      />
    </>
  );
};
